export default __webpack_public_path__ + "static/media/signal_4.d061755f.mp3";